import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard,AuthGuardLogin } from './core/gaurds/auth.gaurd';
import { LayoutComponent } from './SmartBook.Other/layout/layout.component';

const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./SmartBook.Other/login/login.module').then(m => m.LoginModule),
        data: { reuse: false }
    },
    {
        path: 'register',
        loadChildren: () => import('./SmartBook.Other/register-user/register-user.module').then(m => m.RegisterUserModule),
        data: { reuse: false }
    },
    {
        path: 'main',
        component: LayoutComponent,
        children: [{
            path: 'dashboard',
            loadChildren: () => import('./SmartBook.Other/dashboard/dashboard.module').then(m => m.DashboardModule),
            canActivate: [AuthGuard],
            data : { title : 'MenuCP.AnalyzeDashboard'}
        },
        {
            path: 'gl',
            loadChildren: () => import('./SmartBook.GL/gl.module').then(m => m.GLModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'ap',
            loadChildren: () => import('./SmartBook.AP/ap.module').then(m => m.APModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'ar',
            loadChildren: () => import('./SmartBook.AR/ar.module').then(m => m.ARModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'ca',
            loadChildren: () => import('./SmartBook.CA/ca.module').then(m => m.CAModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'fa',
            loadChildren: () => import('./SmartBook.FA/fa.module').then(m => m.FAModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'inventory',
            loadChildren: () => import('./SmartBook.Inventory/inventory.module').then(m => m.InventoryModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'sa',
            loadChildren: () => import('./SmartBook.Sales/sa.module').then(m => m.SAModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'so',
            loadChildren: () => import('./SmartBook.SO/so.module').then(m => m.SOModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'po',
            loadChildren: () => import('./SmartBook.PO/po.module').then(m => m.POModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'ei',
            loadChildren: () => import('./SmartBook.EI/ei.module').then(m => m.EIModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'bg',
            loadChildren: () => import('./SmartBook.BG/bg.module').then(m => m.BGModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'setup_tools',
            loadChildren: () => import('./SmartBook.SetupTools/setup_tools.module').then(m => m.SetupToolsModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'use_full',
            loadChildren: () => import('./SmartBook.UseFull/use_full.module').then(m => m.UseFullModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'general',
            loadChildren: () => import('./SmartBook.General/general.module').then(m => m.GeneralModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'sp',
            loadChildren: () => import('./SmartBook.SP/sp.module').then(m => m.SPModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'cp',
            loadChildren: () => import('./SmartBook.CP/cp.module').then(m => m.CPModule),
            canActivate: [AuthGuard]
        }
    ]
    },
    { path: '',
    redirectTo: 'main/dashboard',
    pathMatch: 'full' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
    // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
    // Pls refer to https://ng-alain.com/components/reuse-tab
    scrollPositionRestoration: 'top',
    relativeLinkResolution: 'legacy'
})
      ],
      exports: [RouterModule]
})
export class AppRoutingModule { }